/**
 *
 * 项目全局配置文件
 */
import { gatewayfuns } from '@zjtscs/jr-utils';

/**
 * platformTypes 平台类型生产标识
 * env 当前环境标识
 * locationTagName 本地tag名称
 * dev 开发环境，要搭配locationTagName=base使用
 */
const gatewayUtils = gatewayfuns.gatewayUtils({ platformTypes: ['finance'], env: 'dev', locationTagName: 'base', customHost: 'gzwenhuo' });

export const getEnv = gatewayUtils.checkEnv; // 获取当前环境

export const getMseTag = gatewayUtils.checkMseTag; // 获取当前tag

// 获取 api 前置路径
export const API_BASE = (function fn() {
  const env = getEnv();
  const APIS = {
    prod: gatewayUtils.prodHostConfig(),
    pre: gatewayUtils.preHostConfig(),
    others: gatewayUtils.baseHostConfig(),
  };
  return APIS[env] || APIS.others;
}());

// 环境域名对应的前缀
export const ENV_PREFIX = window.location.host;

// 多语言配置
export const LANGUAGES = [
  { name: '中文简体', lang: 'zh' },
  { name: 'English', lang: 'en' },
];

// 是否开启 mock data
export const HAS_MOCK = false;

// 内容区域的 page header 显示内容默认配置.
// 可配置: ['breadcrumb', 'pageInfo'], ['breadcrumb'], ['pageInfo'], []
export const PAGE_HEADER = ['breadcrumb'];

// 是否显示标签栏
export const SHOW_TAGS_VIEW = false;

// 首页路由配置
export const HOME_ROUTE = {
  path: '/dashboard',
  name: 'dashboard',
  meta: {
    title: '首页',
    icon: 'home',
  },
};

function recursiveRouters(routerList, list = []) {
  routerList.forEach((item) => {
    const it = {
      menuId: item.path,
      url: item.path,
      menuName: item.meta.title,
      type: 'FIRST_LEVEL_MENU',
      icon: item.meta.icon,
    };
    if (item.children && item.children.length) {
      it.children = [];
      recursiveRouters(item.children, it.children);
    }
    list.push(it);
  });
  return list;
}

// 初始化路由配置
const INIT_ROUTERS = [HOME_ROUTE];
if (process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line global-require
  const { routerLabsMap } = require('@/router');
  INIT_ROUTERS.push(...routerLabsMap);
}
// 处理 INIT_ROUTERS 数据格式
const routerList = recursiveRouters(INIT_ROUTERS);
export const INIT_MENUS = [
  ...routerList,
];

export const COPYRIGHT = 'Copyright © 2022 广州鑫景信息科技服务有限公司';
